import { render, staticRenderFns } from "./ThumbItemList.vue?vue&type=template&id=1845d674&scoped=true&lang=pug&"
import script from "./ThumbItemList.vue?vue&type=script&lang=js&"
export * from "./ThumbItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1845d674",
  null
  
)

export default component.exports